export default function ExternalDashboardCell(props) {
  const { data: externalDashboard } = props

  return (
    <div className='external-dashboard-cell-comp'>
      <p>{externalDashboard?.name}</p>
      <p className='subtitle'>{externalDashboard?.externalService}</p>
    </div>
  )
}